import { ADMIN_LEVELS } from '../authProvider';

export const ConfigTypeEnum = [
  { id: 'bank_link', name: 'Bank Link Configuration' },
  { id: 'bank_transfer', name: 'Bank Transfer Configuration' },
];

export const adminLevelLabels = [
  { id: null, name: 'None' },
  { id: ADMIN_LEVELS.FULL_ADMIN, name: 'Full Admin' },
  { id: ADMIN_LEVELS.SUPERVISOR_ADMIN, name: 'Supervisor Admin' },
  { id: ADMIN_LEVELS.REGULAR_ADMIN, name: 'Regular Admin' },
  { id: ADMIN_LEVELS.READ_ONLY_ADMIN, name: 'Read Only Admin' },
];

export const annualIncomeChoices = [
  { id: '1', name: '$0 to $25,000' },
  { id: '2', name: '$25,001 to $50,000' },
  { id: '3', name: '$50,001 to $100,000' },
  { id: '4', name: '$100,001 to $200,000' },
  { id: '5', name: '$200,001 to $300,000' },
  { id: '6', name: '$300,001 to $500,000' },
  { id: '7', name: 'Greater than $500,000' },
];

export const netWorthChoices = [
  { id: '1', name: '$0 to $25,000' },
  { id: '2', name: '$25,001 to $50,000' },
  { id: '3', name: '$50,001 to $200,000' },
  { id: '4', name: '$200,001 to $500,000' },
  { id: '5', name: '$500,001 to $1,000,000' },
  { id: '6', name: '$1,000,001 to $2,000,000' },
  { id: '7', name: '$2,000,001 to $3,000,000' },
  { id: '8', name: 'Greater than $3,000,000' },
];

export const trustedContactRelationship = [
  { id: 'S', name: 'Spouse' },
  { id: 'A', name: 'Financial Advisor' },
  { id: 'G', name: 'Gaurdian' },
  { id: 'F', name: 'Family Member' },
  { id: 'L', name: 'Lawyer/Attorney' },
  { id: 'O', name: 'Other' },
];

export const citizenshipLabels = {
  C: 'U.S. Citizen',
  R: 'Resident Alien',
};

export const securityDeliveryInformationOptionTypes = {
  RADIO_LIST: {
    label: 'RadioList',
    value: 'radio_list',
  },
};

export const subscriptionAgreement = {
  DEFAULT: {
    label: 'Default (Fat Brands)',
    value: 'default_fat_brands',
  },
  KNIGHTSCOPE: {
    label: 'KnightScope',
    value: 'knightScope',
  },
};

export const offeringCategory = {
  NORMAL: {
    label: 'Standard',
    value: 0,
  },
  CONDITIONAL: {
    label: 'Conditional',
    value: 1,
  },
  COMING_SOON: {
    label: 'Coming Soon',
    value: 2,
  },
  TESTING_WATERS: {
    label: 'Testing the Waters',
    value: 3,
  },
};

export const offerType = {
  REG_A: {
    label: 'Reg A+',
    value: 'Reg A+',
  },
  REG_A_NASDAQ: {
    label: 'Reg A+ & NASDAQ Public Listing',
    value: 'Reg A+ & NASDAQ Public Listing',
  },
  RED_D_B: {
    label: 'Reg D: 506(b)',
    value: 'Reg D: 506(b)',
  },
  REG_D_C: {
    label: 'Reg D: 506(c)',
    value: 'Reg D: 506(c)',
  },
  PROSPECTUS_S1: {
    label: 'Prospectus: S-1',
    value: 'Prospectus: S-1',
  },
  PROSPECTUS_S3: {
    label: 'Prospectus: S-3',
    value: 'Prospectus: S-3',
  },
  PROSPECTUS_S11: {
    label: 'Prospectus: S-11',
    value: 'Prospectus: S-11',
  },
};

export const offerIndustry = {
  REAL_ESTATE: {
    label: 'Real Estate',
    value: 'Real Estate',
  },
  REAL_ESTATE_REIT: {
    label: 'Real Estate (REIT)',
    value: 'Real Estate (REIT)',
  },
  DEATHCARE: {
    label: 'Deathcare',
    value: 'Deathcare',
  },
  LIFE_INS: {
    label: 'Life Insurance Settlements',
    value: 'Life Insurance Settlements',
  },
  BREWERY: {
    label: 'Brewery',
    value: 'Brewery',
  },
  RESTAURANT: {
    label: 'Restaurant',
    value: 'Restaurant',
  },
  AUTONOMOUS_SECURITY: {
    label: 'Autonomous Security',
    value: 'Autonomous Security',
  },
};

export const offerSecurityType = {
  COMMON_STOCK: {
    label: 'Common Stock',
    value: 'Common Stock',
  },
  COMMON_STOCK_NT: {
    label: 'Common Stock: Non-Traded',
    value: 'Common Stock: Non-Traded',
  },
  EQUITY: {
    label: 'Equity',
    value: 'Equity',
  },
  PREFERRED_STOCK: {
    label: 'Preferred Stock',
    value: 'Preferred Stock',
  },
  PREFERRED_STOCK_NT: {
    label: 'Preferred Stock: Non-Traded',
    value: 'Preferred Stock: Non-Traded',
  },
};

export const offeringInterestIndicationStatuses = {
  NOT_WATCHING: 'NOT_WATCHING',
  WATCHING: 'WATCHING',
  REMOVED_WATCHING: 'REMOVED_WATCHING',
};

export const externalOfferSelection = {
  FOLIO_OFFER: {
    label: 'Folio offer',
    value: false,
  },
  EXTERNAL_OFFER: {
    label: 'Escrow offer',
    value: true,
  },
};

export default {
  offeringCategory,
  offeringInterestIndicationStatuses,
  externalOfferSelection,
};



// WEBPACK FOOTER //
// ./src/helpers/mappings.js